import React, { useEffect, useRef, useState } from 'react';
import axiosInsatnace, { chatStatus, contactView, getSearch } from '../../../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import defaultImage from "../../../images/no-photo.png";
import { Box, Button, ButtonBase, Chip, CircularProgress, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Skeleton, Typography, useMediaQuery } from '@mui/material';
import { AddCircleSharp, Call, Chat, Check, Close, NotificationsActive, RemoveCircleSharp, Send, Star } from '@mui/icons-material';
import educIcon from "../../../images/educIcon.png";
import jobIcon from "../../../images/jobIcon.png";
import heightIcon from "../../../images/heightIcon.png";
import Profileicon from "../../../images/Profileicon.png";
import goldIcon from "../../../images/gold.png";
import platinumIcon from "../../../images/platinum.png";
import diamondIcon from "../../../images/diamond.png";
import premiumPlusIcon from "../../../images/premiumPlus.png";
import tillUMarryIcon from "../../../images/marry.png";

import popup from "../../../images/popup_design.png";
import TimeDateIcon from "../../../images/TimeDateIcon.png";
import shortlistIcon from "../../../images/shortlistIcon.png";
import SendInterest from "../../../images/SendInterest.png";
import IgnoreIcon from "../../../images/IgnoreIcon.png";
import ContactIcon from "../../../images/ContactIcon.png";
import AcceptInterestIcon from "../../../images/AcceptInterestIcon.png";
import BookMarkRemoveIcon from "../../../images/BookmarkIcon.png";
import DeclinedInterestIcon from "../../../images/DelinedIcon.png";
import sendRemidIcon from "../../../images/SendReminderIcon.png";
import ChatIcon from "../../../images/ChatIcon.png";
import RemoveIgnoreIcon from "../../../images/RemoveIgnoreIcon.png";
import { useTheme } from "@mui/material/styles";
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../../services/firebaseConfig';
import MessengerModal from '../../MessengerModel';


const packageIcons = {
    Gold: goldIcon,
    Platinum: platinumIcon,
    Diamond: diamondIcon,
    Premium: premiumPlusIcon,
    "Premium +": premiumPlusIcon,
    "Till U Marry": tillUMarryIcon,
};
export const SearchResult = () => {
    const [result, setResult] = useState([]);
    const [loading, setLoading] = useState(false);
    const [contactInfo, setContactInfo] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [error, setError] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();
    const lastMatchElementRef = useRef();
    const { searchResult } = location.state || {};
    const token = localStorage.getItem('token');
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const username = localStorage.getItem('username');
    const [openMessengerModal, setOpenMessengerModal] = useState(false);
    // Utility function to check and filter duplicates
    const removeDuplicates = (newData) => {
        const uniqueIds = new Set(); // Set to track unique IDs
        return newData.filter(item => {
            // Check if the item ID is already in the Set
            if (uniqueIds.has(item.id)) {
                return false; // Skip duplicate
            } else {
                uniqueIds.add(item.id); // Add to Set
                return true; // Keep unique item
            }
        });
    };

    // Fetch search result data
    const fetchResult = async (page) => {
        setLoading(true);
        setError(null);  // Reset error state before fetching
        try {
            const response = await getSearch({ ...searchResult, page });

            if (response.status === 200 || response.status === 201) {
                const fetchedData = response.data.data.data;
                if (fetchedData.length === 0) {
                    setHasMore(false);  // No more data to load
                } else {
                    // Filter out duplicate entries before updating the result state
                    const uniqueData = removeDuplicates(fetchedData);
                    console.log('Fetched Data:', fetchedData); // Log fetched data
                    console.log('Unique Data:', uniqueData); // Log unique data

                    // Use functional update to avoid stale state
                    setResult(prevResults => {
                        const combinedResults = [...prevResults, ...uniqueData];
                        return removeDuplicates(combinedResults); // Remove duplicates after merging
                    });
                }
            } else {
                toast.error("Failed To Search Result");
            }
        } catch (error) {
            setError("An error occurred while fetching data.");
            toast.error("Error fetching search results");
        } finally {
            setLoading(false);  // Stop loading after fetch or error
        }
    };

    // Effect to handle fetching when page changes
    useEffect(() => {
        if (hasMore) {
            fetchResult(page);
        }
    }, [page]);

    // Intersection Observer to load more results when scrolling
    useEffect(() => {
        if (loading || !hasMore) return;  // Prevent additional API calls while loading or when no more data

        const observerCallback = (entries) => {
            if (entries[0].isIntersecting) {
                setPage(prevPage => prevPage + 1);
            }
        };

        const observerInstance = new IntersectionObserver(observerCallback);
        if (lastMatchElementRef.current) {
            observerInstance.observe(lastMatchElementRef.current);
        }

        return () => {
            if (lastMatchElementRef.current) {
                observerInstance.unobserve(lastMatchElementRef.current);
            }
        };
    }, [loading, hasMore]);
    const handleAction = async (url, data, label) => {
        setLoading(label); // set loading state to the current action label
        try {
            const response = await axiosInsatnace.post(url, data);
            if (response.status === 200 || response.status === 201) {

                logEvent(analytics, 'user_action', {
                    user_id: localStorage.getItem('user'),
                    profile_id: data.user_id,
                    action: data.response_type,
                    platform: 'web',
                    timestamp: new Date().toISOString(),
                })
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
            // window.location.reload();
        } catch (error) {
            toast.error(error.response?.data?.message);
        } finally {
            setLoading(null); // reset loading state after response
        }
    };
    const handleReminder = async (url, data, label) => {
        setLoading(label); // set loading state to the current action label
        try {
            const response = await axiosInsatnace.post(url, data);
            if (response.status === 200 || response.status === 201) {
                logEvent(analytics, 'sendReminder', {
                    user_id: localStorage.getItem('user'),
                    profile_id: data.user_id,
                    action: data.response_type,
                    platform: 'web',
                    timestamp: new Date().toISOString(),
                })
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message);
        } finally {
            setLoading(null); // reset loading state after response
        }
    };
    const handleContactClick = async (recipientId) => {
        setLoading("Contact");
        try {
            const response = await contactView({ profile_id: recipientId });
            if (response.status === 200 || response.status === 201) {
                logEvent(analytics, 'view_contact', {
                    user_id: localStorage.getItem('user'),
                    profile_id: recipientId,
                    action: 'contact_view',
                    platform: 'web',
                    timestamp: new Date().toISOString(),
                });
                setContactInfo(response.data.data);
                setOpenModal(true);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to retrieve contact info');
        } finally {
            setLoading(null);
        }
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const startChat = async (recipientId, profile) => {
        // const currentUserId = username;
        // const chatId = [currentUserId, recipientId].sort().join('_');
        // try {
        //     const response = await chatStatus({ profile_id: profile.id });

        //     const { SUCCESS, ERROR, chatReason, chatAllowed } = response.data;
        //     if (SUCCESS === 1 && chatAllowed === "true") {
        //         navigate(`/chat`, { state: { chatId, recipientId, profile } });

        //     } else {
        //         toast.error(ERROR || chatReason);
        //     }
        // } catch (error) {
        //     toast.error("Error starting chat:", error);
        // }
        setOpenMessengerModal(true);

    };
    const getActionButton = (profile) => {
        const { send, received, ignored, bookmarked } = profile;
        if (ignored) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    {/* <Button startIcon={<Chat />} variant="text" className='actionTxt'>Chat</Button> */}
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { token, user_id: ignored.member_id, response_type: 'remove_ignore' })} >
                        <img src={RemoveIgnoreIcon} alt="Remove Ignore" className="action-icon" />
                        <Typography variant="body2">Remove Ignore</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Star />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: profile.id, response_type: 'bookmark' })}>Shortlist</Button> */}
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)} >
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (bookmarked && !send && !received) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { token, user_id: profile.id, response_type: 'interest' })} >
                        <img src={SendInterest} alt="Send Interest" className="action-icon" />
                        <Typography variant="body2">Send Interest</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { token, user_id: profile.id, response_type: 'remove_bookmark' })} >
                        <img src={BookMarkRemoveIcon} alt="Remove Bookmark" className="action-icon" />
                        <Typography variant="body2">Remove Bookmark</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)} >
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: send.recipient, response_type: 'reject' })}>Cancel Interest</Button> */}
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (bookmarked && send && send.accept === 0 && send.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { token, user_id: profile.id, response_type: 'remove_bookmark' })} >
                        <img src={BookMarkRemoveIcon} alt="Remove Bookmark" className="action-icon" />
                        <Typography variant="body2">Remove Bookmark</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => handleReminder('profile-activity', { token, user_id: profile.id, response_type: 'send_reminder' })}>
                        <img src={sendRemidIcon} alt="Send Reminder" className="action-icon" />
                        <Typography variant="body2">Send Reminder</Typography>
                    </ButtonBase>

                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)} >
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: send.recipient, response_type: 'reject' })}>Cancel Interest</Button> */}
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (bookmarked && send && send.accept === 1 && send.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { token, user_id: profile.id, response_type: 'remove_bookmark' })} >
                        <img src={BookMarkRemoveIcon} alt="Remove Bookmark" className="action-icon" />
                        <Typography variant="body2">Remove Bookmark</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)} >
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<RemoveCircleSharp />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: send.recipient, response_type: 'ignored' })}>Ignore</Button> */}
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (bookmarked && received && received.accept === 0 && received.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { token, user_id: profile.id, response_type: 'remove_bookmark' })} >
                        <img src={BookMarkRemoveIcon} alt="Remove Bookmark" className="action-icon" />
                        <Typography variant="body2">Remove Bookmark</Typography>
                    </ButtonBase>
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { token, user_id: received.sender, response_type: 'accept' })}>
                        <img src={AcceptInterestIcon} alt="Accept Interest" className="action-icon" />
                        <Typography variant="body2">Accept Interest</Typography>
                    </ButtonBase>
                    <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: received.sender, response_type: 'reject' })}>Decline Interest</Button>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (bookmarked && received && received.accept === 1 && received.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    {/* <Button startIcon={<Chat />} variant="text" className='actionTxt'>Chat</Button> */}
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { token, user_id: profile.id, response_type: 'remove_bookmark' })} >
                        <img src={BookMarkRemoveIcon} alt="Remove Bookmark" className="action-icon" />
                        <Typography variant="body2">Remove Bookmark</Typography>
                    </ButtonBase>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: received.sender, response_type: 'reject' })}>Decline Interest</Button> */}
                </Box>
            );
        } else if (!bookmarked && send && send.accept === 0 && send.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => handleReminder('profile-activity', { token, user_id: profile.id, response_type: 'send_reminder' })}>
                        <img src={sendRemidIcon} alt="Send Reminder" className="action-icon" />
                        <Typography variant="body2">Send Reminder</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)} >
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: send.recipient, response_type: 'reject' })}>Cancel Interest</Button> */}
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (!bookmarked && send && send.accept === 1 && send.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)} >
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<RemoveCircleSharp />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: send.recipient, response_type: 'ignored' })}>Ignore</Button> */}
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>

                </Box>
            );
        } else if (!bookmarked && send && send.accept === 0 && send.reject === 1) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className='action-item' onClick={() => startChat(profile.username, profile)} >
                        <img src={ChatIcon} alt="Chat" className="action-icon" />
                        <Typography variant="body2">Chat</Typography>
                    </ButtonBase>
                    <Button startIcon={<RemoveCircleSharp />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: send.recipient, response_type: 'ignored' })}>Ignore</Button>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (!bookmarked && received && received.accept === 0 && received.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { token, user_id: received.sender, response_type: 'accept' })}>
                        <img src={AcceptInterestIcon} alt="Accept Interest" className="action-icon" />
                        <Typography variant="body2">Accept Interest</Typography>
                    </ButtonBase>
                    <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: received.sender, response_type: 'reject' })}>Decline Interest</Button>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>
            );
        } else if (!bookmarked && received && received.accept === 1 && received.reject === 0) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    {/* <Button startIcon={<Chat />} variant="text" className='actionTxt'>Chat</Button> */}
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { token, user_id: received.sender, response_type: 'ignored' })}>
                        <img src={IgnoreIcon} alt="Ignore" className="action-icon" />
                        <Typography variant="body2">Ignore</Typography>
                    </ButtonBase>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                    {/* <Button startIcon={<Close />} variant="text" className='actionTxt' onClick={() => handleAction('profile-activity', { token, user_id: received.sender, response_type: 'reject' })}>Decline Interest</Button> */}
                </Box>
            );
        } else if (!bookmarked && (send && send?.accept === 1) || !bookmarked && (received && received?.accept === 1)) {

            <Box display="flex" className="action-container" justifyContent="space-between">
                {/* <Button startIcon={<Chat />} variant="text" className='actionTxt'>Chat</Button> */}
                <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { token, user_id: send.recipient, response_type: 'ignored' })}>
                    <img src={IgnoreIcon} alt="Ignore" className="action-icon" />
                    <Typography variant="body2">Ignore</Typography>
                </ButtonBase>
                <ButtonBase
                    className="action-item"
                    onClick={() => handleContactClick(profile.id)}
                >
                    <img src={ContactIcon} alt="Contact" className="action-icon" />
                    <Typography variant="body2">Contact</Typography>
                </ButtonBase>
                <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { token, user_id: send.recipient, response_type: 'reject' })}>
                    <img src={DeclinedInterestIcon} alt="Decline Interest" className="action-icon" />
                    <Typography variant="body2">Decline Interest</Typography>
                </ButtonBase>
            </Box>

        } else if (!bookmarked && received && received.reject === 1) {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { token, user_id: received.sender, response_type: 'accept' })}>
                        <img src={AcceptInterestIcon} alt="Accept Interest" className="action-icon" />
                        <Typography variant="body2">Accept Interest</Typography>
                    </ButtonBase>
                    <ButtonBase className='action-item' onClick={() => handleAction('profile-activity', { token, user_id: received.sender, response_type: 'ignored' })}>
                        <img src={IgnoreIcon} alt="Ignore" className="action-icon" />
                        <Typography variant="body2">Ignore</Typography>
                    </ButtonBase>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>

                </Box>
            )
        } else {
            return (
                <Box display="flex" className="action-container" justifyContent="space-between">
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { token, user_id: profile.id, response_type: 'interest' })}>
                        <img src={SendInterest} alt="Send Interest" className="action-icon" />
                        <Typography variant="body2">Send Interest</Typography>
                    </ButtonBase>
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { token, user_id: profile.id, response_type: 'bookmark' })}>
                        <img src={shortlistIcon} alt="Shortlist" className="action-icon" />
                        <Typography variant="body2">Shortlist</Typography>
                    </ButtonBase>
                    <ButtonBase className="action-item" onClick={() => handleAction('profile-activity', { token, user_id: profile.id, response_type: 'ignored' })}>
                        <img src={IgnoreIcon} alt="Ignore" className="action-icon" />
                        <Typography variant="body2">Ignore</Typography>
                    </ButtonBase>
                    <ButtonBase
                        className="action-item"
                        onClick={() => handleContactClick(profile.id)}
                    >
                        <img src={ContactIcon} alt="Contact" className="action-icon" />
                        <Typography variant="body2">Contact</Typography>
                    </ButtonBase>
                </Box>

            );
        }
    }
    const handleSearch = (profileId) => {
        // Navigate to the profile view with the user_id
        logEvent(analytics, "view_profile", {
            viewed_profile_id: profileId,
            profile_viewer_id: localStorage.getItem('user'),
            platform: 'web',
            timestamp: new Date().toISOString(),
        })
        navigate('/profile-view', { state: { user_id: profileId } });
    };
    return (

        <div className="col-lg-9 col-12">
            {loading ? (
                Array.from(new Array(4)).map((_, index) => (
                    <div className="girlBG mt-3" key={index}>
                        <div className="row">
                            <div className="col-md-4">
                                <Skeleton variant="rectangular" width="100%" height={150} />
                            </div>
                            <div className="col-md-8">
                                <Skeleton variant="text" width="80%" height={30} style={{ marginTop: 10 }} />
                                <Skeleton variant="text" width="60%" />
                                <Skeleton variant="text" width="80%" />
                                <Skeleton variant="text" width="60%" />
                                <Skeleton variant="text" width="40%" />
                                <Skeleton variant="text" width="30%" />
                            </div>
                        </div>
                    </div>
                ))
            ) : result.length === 0 ? (
                <div>No Matching Result Found</div>
            ) : (


                result.map((item, index) => (
                    <>
                        <div className="girlBG mt-3" key={item.id} ref={index === result.length - 1 ? lastMatchElementRef : null}>
                            <div className="row">
                                <div className="col-md-4" onClick={() => handleSearch(item.username)}>
                                    <div className="girlPic h-100">
                                        <img src={item.photo ? item.photo : defaultImage} className="img-fluid" alt="girl image" />
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    {item.membership_type && item.membership_type !== 'Free' && (
                                        <Grid
                                            container
                                            justifyContent={isSmallScreen ? 'flex-end' : 'flex-end'}
                                        >
                                            <Chip
                                                icon={
                                                    <img
                                                        src={packageIcons[item.membership_type]}
                                                        alt={`${item.membership_type} icon`}
                                                        style={{ width: '20px', height: '20px' }}
                                                    />
                                                }
                                                label={item.membership_type}
                                                variant="outlined"
                                                sx={{
                                                    textTransform: 'uppercase',
                                                    fontWeight: 'bold',
                                                    fontSize: '0.85rem',
                                                    padding: '5px 10px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    backgroundColor: '#ffa779',
                                                    marginTop: isSmallScreen ? 1 : 0,
                                                }}
                                            />
                                        </Grid>
                                    )}
                                    <div className="girlsDetail float-start text-left">
                                        <p>
                                            <img src={TimeDateIcon} width='24px' /> {item.last_login || "N/A"}
                                        </p>
                                        <p>
                                            <img src={Profileicon} width='24px' /> {item.name} {item.last_name ? ` ${item.last_name}` : ""}, {item.city || "N/A"}
                                        </p>
                                        <p>
                                            <img src={heightIcon} width='24px' />
                                            {item.heightValue ? item.heightValue + " - " : ""}
                                            {item.age ? item.age + " yr " : ""}
                                            {item.cast ? "-" + item.cast : ""}
                                        </p>
                                        <p>
                                            <img src={jobIcon} width='24px' />
                                            {item.occupation || ""}
                                            {item.income_type ? ` - ${item.income_type} P.A` : ""}
                                        </p>
                                        <p>
                                            <img src={educIcon} width='24px' />
                                            {item.education || ""}
                                            {item.status ? ` - ${item.status}` : ""}
                                        </p>

                                    </div>
                                    <div className="clearfix"></div>
                                    {/* <div className="d-flex justify-content-between align-items-between actionBG text-center"> */}
                                    {getActionButton(item)}
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>

                        <Dialog
                            open={openModal}
                            onClose={handleCloseModal}
                            aria-labelledby="contact-dialog-title"
                            maxWidth="sm"
                            fullWidth
                            sx={{
                                '& .MuiPaper-root': {
                                    width: '500px',
                                    height: '400px',
                                    padding: 4,
                                    backgroundImage: `url('${popup}')`, // Replace with your image URL
                                    backgroundSize: 'cover', // Ensures the image covers the entire background
                                    backgroundRepeat: 'no-repeat', // Prevents tiling
                                    backgroundPosition: 'center', // Centers the image
                                },
                            }}
                        >
                            <DialogTitle id="contact-dialog-title" align="center">
                                <Typography variant="h5">
                                    {contactInfo?.text || ''}
                                </Typography>
                                <Divider variant="middle" sx={{ mb: 2 }} />
                                <IconButton
                                    aria-label="close"
                                    onClick={handleCloseModal}
                                    sx={{
                                        position: 'absolute',
                                        right: 8,
                                        top: 8,
                                        color: (theme) => theme.palette.grey[500],
                                    }}
                                >
                                    <Close />
                                </IconButton>
                            </DialogTitle>
                            <DialogContent>
                                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                                    <div className="viewCall">
                                        {contactInfo ? (
                                            <>
                                                <img src={contactInfo && contactInfo.photo ? contactInfo.photo : defaultImage} style={{ width: '60px', height: '60px', borderRadius: '50%' }} alt="Profile" />
                                                <p className="mt-2">{contactInfo?.username}</p>

                                                <Typography variant="body1">Email: {contactInfo.email}</Typography>
                                                <Typography variant="body1">Phone: {contactInfo.mobileNumber}</Typography>
                                            </>
                                        ) : (
                                            <Typography variant="body2">Loading...</Typography>
                                        )}
                                    </div>
                                </Box>
                            </DialogContent>
                            <div className="d-grid p-3">
                                <a href="/upgrade" target="_blank" className="btn btn-danger vplan">View Plan</a>
                            </div>
                        </Dialog>
                    </>
                ))
            )}
            {loading && <p>Loading...</p>}
            {error && <p>{error}</p>}
            <ToastContainer />
            <MessengerModal
                open={openMessengerModal}
                onClose={() => setOpenMessengerModal(false)}
            />

        </div>
    );
};
